import dayjs, { type Dayjs } from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);

export enum DateFormat {
    MonthAndDayOfTheMonth = 'MMM Do',
    DayOfTheWeek = 'dddd',
    DayOfTheWeekShort = 'ddd',
}

export enum TimeFormat {
    HoursAndMinutesAndMeridiem = 'h:mm A',
}

export const formatDateTime = (
    str: Dayjs | Date | string | number,
    format: DateFormat | TimeFormat | string,
    fallback = '',
): string => {
    if (!str) {
        return fallback;
    }

    return dayjs(str).format(format);
};

export const formatTimelineDate = (timestamp: string): string => {
    const date = dayjs.utc(timestamp).local();
    const now = dayjs();
    const minutesDiff = now.diff(date, 'minute');

    const dateStartOfDay = date.startOf('day');
    const nowStartOfDay = now.startOf('day');
    const daysDiff = nowStartOfDay.diff(dateStartOfDay, 'day');

    if (minutesDiff < 60 && minutesDiff >= 0) {
        return date.fromNow();
    } else if (daysDiff === 0) {
        return `Today ${date.format('h:mm A')}`;
    } else if (daysDiff === 1) {
        return `Yesterday ${date.format('h:mm A')}`;
    } else {
        return date.format('MM/DD/YY');
    }
};
